import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StoreService {
  public iloop: any = [];
  public cartItems: any = [];
  constructor() {
    for (var i = 1; i <= 20; i++) {
      this.iloop.push(i);
    }
  }

  public addToCart() {
    this.cartItems.push(1);
  }

  public removeFromCart() {
    this.cartItems.pop();
  }
}
